import { ISbStoryData } from 'storyblok-js-client';

import { Locales } from '@monoimin/sb-types';

import { getStoryAlterSlugs } from '../utils';

/**
 * get all alternates array for AlternatePageMediator from a story
 */
export const defineAllAlternates = ({
  story,
}: {
  story: ISbStoryData;
  locale?: Locales;
}) => {
  const slugsByLocales = getStoryAlterSlugs(story);

  const allAlternates = Object.entries(slugsByLocales).map(
    ([locale, slug]) => ({ locale: locale as Locales, slug })
  );

  return allAlternates;
};

export const removeLocaleFromPathname = (
  pathname: string | null,
  locale: Locales
) => {
  const splittedPath = pathname
    ? pathname.split('/').filter((item) => {
        return Boolean(item) && item !== locale;
      })
    : [];

  return `/${splittedPath.join('/')}/`;
};
